import React from 'react'
import { PillButton } from '../../../../../general/buttons/pill-button'
import { graphql } from 'gatsby'
import RichText from '../../../../../general/rich-text/RichText';
import { SmartLink } from '../../../../../general/link';

const LocationListItem = ({data}) => {
    // console.log(data.node)
    return (
        <div className='list-item'>  
            <div>
                <p className="text-m">
                    {data.node.name}
                </p>
            </div>
            <div className='center'>
                <RichText>{data.node.description}</RichText>
            </div>

            <div>
                <a href={data.node.website} target="_blank"><PillButton invert action={data.node.website ? data.node.website : "No website"} actionType="external-link">Visit Website</PillButton></a>
                <a href={data.node.social} target="_blank"><PillButton invert action={data.node.social ? data.node.social : "No social"} actionType="external-link">Social</PillButton></a>
            </div>

            <style jsx>{`

                .list-item {
                    display: grid;
                    grid-template-columns: 360px 1fr 150px;
                    margin-bottom: 40px;
                    padding: 0 120px;
                }

                .list-item > div {
                    padding: 20px 0px;
                }

                .list-item .center {
                    padding: 20px 60px;
                }

                .list-item :global(.pill-button) {
                    width: 100%;
                    text-align: center;
                    margin: 4px 0;
                }
                @media (max-width: 1100px) {
                    .list-item {
                        grid-template-columns: 1fr 2fr 150px;
                        padding: 0 20px;
                    }
                }
                @media (pointer: coarse), (max-width: 769px) {
                    .list-item {
                        display: block;
                        padding: 0;
                        margin-bottom: 60px;
                    }
                    .list-item > div {
                        padding: 0;
                    }

                    .list-item .center {
                        padding: 0;
                    }

                    .center {
                        margin: 12px 0 20px;
                    }
                }
            `}</style>
        </div>
    )
}


export const query = graphql`
    fragment Organization on ContentfulOrganization {
        name
        city
        website
        donationURL
        social
        slug
        description {
            raw
        }
        mapLocation {
            x
            y
        }
        shareCardImage {
            ...ImageData  
        }
    }
`

export default LocationListItem